import { SearchIcon } from "lucide-react"
import { useGetBackofficeReferralsQuery } from "modules/backoffice/hooks/referrals/useGetBackofficeReferralsQuery"
import { Pagination } from "modules/shared/components/Pagination"
import { SearchQuery } from "modules/shared/components/SearchQuery"
import { usePagination } from "modules/shared/hooks/usePagination"
import { useSearchQuery } from "modules/shared/hooks/useSearchQuery"
import { useTranslation } from "react-i18next"
import { Route as BackofficeReferralsRoute } from "routes/_base/_auth/backoffice/referrals/list"
import { BackofficeReferralsTable } from "./BackofficeReferralsTable"

const ITEMS_PER_PAGE = 25

export function BackofficeReferrals() {
  const { t } = useTranslation()
  const search = BackofficeReferralsRoute.useSearch()

  const { page, totalPages, setPage, setCount, count } = usePagination({
    search,
    fullPath: BackofficeReferralsRoute.fullPath,
    total: ITEMS_PER_PAGE,
  })

  const { query, setQuery } = useSearchQuery({
    search,
    fullPath: BackofficeReferralsRoute.fullPath,
    onSearchQueryChange: () => setPage(1),
  })

  const { data, isPending } = useGetBackofficeReferralsQuery({
    query: {
      query,
      page,
      total: ITEMS_PER_PAGE,
      sortBy: { field: search.field, order: search.order },
    },
    onSuccess: (data) => {
      setCount(data.pageInfo.count)
    },
  })

  return (
    <div className="flex flex-col gap-4">
      <SearchQuery
        placeholder={t("backoffice.referrals.search")}
        setQuery={setQuery}
        defaultValue={query}
        icon={SearchIcon}
      />
      <BackofficeReferralsTable referrals={data} isPending={isPending} />
      <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} count={count} />
    </div>
  )
}
